import DOMPurify from 'dompurify';

if (window.trustedTypes && window.trustedTypes.createPolicy) {
  window.trustedTypes.createPolicy('default', {
    createHTML: (string) => DOMPurify.sanitize(string, { RETURN_TRUSTED_TYPE: true }),
    createScriptURL: (string) => {
      const allowed = ['google', 'blob']
      if (allowed.find(each => string.includes(each))) {
        return string;
      }
      return '';
    }
  });
}
